{
  "ui": {
    "feedback": "Σχόλια και ιδέες",
    "credits": "Συντελεστές",
    "currentMaintainer": "Σημερινός υπεύθυνος συντήρησης",
    "maintainerPeriod": "2026 και μετά",
    "originalTeam": "Αρχική ομάδα",
    "creditsCampaigns": "Ζούγκλα & Χριστούγεννα",
    "moreSettings": "Περισσότερες ρυθμίσεις",
    "chooseLanguage": "Διάλεξε τη γλώσσα σου",
    "notebookTools": "Εργαλεία τετραδίου",
    "visualGuide": "Οδηγός με εικόνες",
    "templeSoon": "Έρχεται σύντομα",
    "playAdventure": "Παίξε",
    "story": "Η ιστορία",
    "loadingAdventure": "Ετοιμαζόμαστε για την περιπέτεια…",
    "storyOpening": "Μια σχολική εκδρομή στη ζούγκλα. Ο Μάρκο και η Σοφία εξερευνούν μαζί με τους φίλους τους. Ένα πολύχρωμο πουλί τραβά την προσοχή του Μάρκο και το ακολουθεί ανάμεσα στα δέντρα. Ξαφνικά μένει μόνος. Βοήθησε τους εξερευνητές να βρουν τον δρόμο!",
    "storyEnding": "Ο Μάρκο και η Σοφία φτάνουν μαζί στον χαμένο ναό. Ένα μυστηριώδες πρόσωπο φυλάει την είσοδο. Μια νέα περιπέτεια τους περιμένει!",
    "blockCategories": "Καρτέλες τετραδίου",
    "actions": "Κινήσεις",
    "loops": "Επαναλήψεις",
    "conditions": "Συνθήκες",
    "title": "Run Marco! — Μια περιπέτεια στο τετράδιό σου",
    "home": "Αρχική σελίδα Run Marco",
    "map": "Χάρτης περιπέτειας",
    "worlds": "Διάλεξε περιπέτεια",
    "notebook": "Το τετράδιό μου",
    "notebookToggle": "Άνοιξε ή κλείσε το τετράδιό σου",
    "notebookOpen": "Άνοιξε το τετράδιο",
    "notebookClose": "Δες το μονοπάτι",
    "page": "Σελίδα {number}",
    "level": "Μονοπάτι {number}",
    "run": "Πάμε!",
    "stop": "Σταμάτα",
    "step": "Βήμα",
    "stepTitle": "Εκτέλεσε μία εντολή",
    "reset": "Πίσω στην αρχή",
    "add": "Πρόσθεσε",
    "addLabel": "Διάλεξε εντολή για προσθήκη",
    "addHint": "Ένωσε τις εντολές και πάτησε Πάμε.",
    "undo": "Αναίρεση",
    "clear": "Καθαρή σελίδα",
    "hint": "Μια μικρή βοήθεια",
    "help": "Πώς παίζουμε",
    "settings": "Ρυθμίσεις",
    "language": "Γλώσσα παιχνιδιού",
    "blockLanguage": "Γλώσσα εντολών",
    "blockLanguageNote": "Μπορείς να διαλέξεις άλλη γλώσσα για τις εντολές.",
    "musicOn": "Ενεργοποίηση ήχου",
    "musicOff": "Απενεργοποίηση ήχου",
    "sound": "Μουσική και ηχητικά εφέ",
    "speed": "Ταχύτητα παιχνιδιού",
    "chooseExplorer": "Διάλεξε εξερευνητή",
    "explorer": "Εξερευνητής",
    "marco": "Μάρκο",
    "sophia": "Σοφία",
    "close": "Κλείσιμο",
    "done": "Ας εξερευνήσουμε",
    "loading": "Βρίσκουμε το μονοπάτι…",
    "loadError": "Δεν φορτώθηκε η περιπέτεια. Ανανέωσε τη σελίδα για να δοκιμάσεις ξανά.",
    "imageError": "Δεν φορτώθηκαν κάποιες εικόνες. Ανανέωσε τη σελίδα.",
    "gemGoal": "Βρες το πετράδι",
    "goal": "Βρες το χρυσό αστέρι",
    "cover": "Φώτισε κάθε πλακάκι μία φορά",
    "lit": "{count} / {total} πλακάκια φωτισμένα",
    "explored": "{count} / {total} μονοπάτια εξερευνήθηκαν",
    "facing": "Κοιτάζει {direction} {arrow}",
    "boardLabel": "{name} στο {level}, κοιτάζει {direction}. {steps}. {objective}.",
    "up": "πάνω",
    "down": "κάτω",
    "left": "αριστερά",
    "right": "δεξιά",
    "steps_one": "{count} βήμα",
    "steps_other": "{count} βήματα",
    "blocks_one": "{count} εντολή",
    "blocks_other": "{count} εντολές",
    "stars_one": "{count} αστέρι",
    "stars_other": "{count} αστέρια",
    "place": "Προσθήκη εντολών",
    "atEnd": "Στο τέλος",
    "insideRepeat": "Μέσα στην επανάληψη {number}",
    "insideIf": "Μέσα στο αν {number}",
    "insideElse": "Μέσα στο αλλιώς {number}",
    "readyFirst": "Ένα μικρό βήμα. Πρόσθεσε μια εντολή μπροστά και πάμε!",
    "ready": "Πού θα πάμε; Φτιάξε ένα σχέδιο στο τετράδιό σου.",
    "back": "Πίσω στην αρχή. Οι εντολές σου είναι έτοιμες για νέα δοκιμή.",
    "empty": "Πρόσθεσε πρώτα μία εντολή στο τετράδιό σου.",
    "win": "Βρήκες τον δρόμο!",
    "winCover": "Φώτισες το μονοπάτι!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Τι περιπέτεια!",
    "simpler": "Μπορείς με λιγότερες εντολές;",
    "complete": "Το μονοπάτι ολοκληρώθηκε! Τα καλύτερα αστέρια σου αποθηκεύτηκαν.",
    "next": "Επόμενο μονοπάτι",
    "allWorlds": "Κι άλλες περιπέτειες",
    "replay": "Παίξε ξανά",
    "shortGoal": "Σχεδόν! Πρόσθεσε λίγες εντολές ακόμα για να φτάσεις στο αστέρι.",
    "shortGem": "Σχεδόν! Πρόσθεσε λίγες εντολές ακόμα για να φτάσεις στο πετράδι.",
    "shortCover": "Κάποια πλακάκια μένουν σκοτεινά. Πώς θα φτάσουμε εκεί;",
    "checking": "Κοιτάζουμε το μονοπάτι…",
    "paused": "Σταματήσαμε εδώ. Το Πάμε ξεκινά ξανά από την αρχή.",
    "going": "Φύγαμε!",
    "stepped": "Ένα βήμα πιο κοντά. Πάτησε Βήμα ή Πάμε για συνέχεια.",
    "clueCover": "Ξεκίνα από μια άκρη και ακολούθησε όλο το σχήμα. Με άλμα περνάς πάνω από ένα πλακάκι χωρίς να το φωτίσεις.",
    "clueCondition": "Κοίτα το μονοπάτι μπροστά. Μια συνθήκη βοηθά τον εξερευνητή σου να διαλέξει τι θα κάνει.",
    "clueRepeat": "Ποια βήματα επαναλαμβάνονται; Βάλ’ τα μέσα σε μια εντολή επανάληψης.",
    "clueForward": "Μπροστά είναι η κατεύθυνση που κοιτάζει ο εξερευνητής. Μέτρησε τα πλακάκια μέχρι το αστέρι.",
    "clueGem": "Μπροστά είναι η κατεύθυνση που κοιτάζει ο εξερευνητής. Μέτρησε τα πλακάκια μέχρι το πετράδι.",
    "clueTurn": "Η στροφή αλλάζει κατεύθυνση χωρίς να προχωράς. Ακολούθησε το μονοπάτι με το δάχτυλό σου.",
    "mapNote": "Διάλεξε μονοπάτι. Τα καλύτερα αστέρια σου μένουν μαζί σου.",
    "mapLevel": "Μονοπάτι {number}: {name}. {stars}.",
    "locked": "Ολοκλήρωσε το προηγούμενο μονοπάτι για να ανοίξει αυτό.",
    "soundBlocked": "Πάτησε το κουμπί ήχου για να ακούσεις την περιπέτεια.",
    "clearTitle": "Να γυρίσουμε σε καθαρή σελίδα;",
    "clearNote": "Διαγράφονται οι εντολές αυτού του μονοπατιού. Η Αναίρεση τις επαναφέρει.",
    "keep": "Κράτα τις εντολές",
    "clearConfirm": "Διαγραφή εντολών",
    "fresh": "Καθαρή σελίδα. Πού θα μας πάει το επόμενο σχέδιό σου;",
    "localProgress": "Η πρόοδός σου αποθηκεύεται σε αυτή τη συσκευή.",
    "helpBuild": "Φτιάξε ένα σχέδιο",
    "helpBuildText": "Σύρε εντολές στο τετράδιο και ένωσέ τες. Μπορείς επίσης να διαλέξεις εντολή και να πατήσεις Πρόσθεσε. Διάλεξε «Μέσα στην επανάληψη» για να βάλεις βήματα σε επανάληψη.",
    "helpTurn": "Ακολούθησε τον εξερευνητή σου",
    "helpTurnText": "Μπροστά είναι εκεί που κοιτάζει ο εξερευνητής. Αριστερά και δεξιά στρίβουν χωρίς να προχωρούν. Το άλμα καλύπτει δύο πλακάκια.",
    "helpTry": "Δοκίμασε, δες, ξαναδοκίμασε",
    "helpTryText": "Πάτησε Πάμε για να δοκιμάσεις το σχέδιό σου ή Βήμα για μία εντολή τη φορά. Το κυκλικό βέλος σε γυρίζει στην αρχή και κρατά τις εντολές.",
    "helpWorlds": "Κάθε περιπέτεια έχει τον στόχο της",
    "helpWorldsText": "Στη Ζούγκλα βρες το πετράδι. Στα Χριστούγεννα φώτισε κάθε ανοιχτό πλακίδιο μία φορά. Στον Ναό και στο Αιγαίο ολοκλήρωσε τις επισκευές και τους ορατούς στόχους και φτάσε στην έξοδο.",
    "noTrail": "Δεν έχει μονοπάτι εκεί! Δοκίμασε να στρίψεις πρώτα.",
    "broken": "Η γέφυρα είναι σπασμένη. Μπορείς να περάσεις με άλμα;",
    "blocked": "Κάτι κλείνει τον δρόμο. Δοκίμασε άλμα ή άλλη διαδρομή.",
    "alreadyLit": "Αυτό το πλακάκι είναι ήδη φωτισμένο. Πέρασε από κάθε πλακάκι μία φορά.",
    "loopError": "Αυτό το σχέδιο επαναλαμβάνεται συνέχεια. Δοκίμασε να αλλάξεις την επανάληψη.",
    "repeatError": "Διάλεξε αριθμό επαναλήψεων από 1 έως 99.",
    "unsupported": "Αφαίρεσε την εντολή που δεν υποστηρίζεται και δοκίμασε ξανά.",
    "connect": "Ένωσε τις εντολές σε μία αλυσίδα και πάτησε Πάμε.",
    "path": "μονοπάτι",
    "backpack": "Σακίδιο",
    "templeGems": "Τα πετράδια του ναού",
    "gemsCollected": "Πετράδια: {count} / {total}",
    "gemsReady": "Μάζεψες όλα τα πετράδια!",
    "aegeanTitle": "Τα μυστικά του Αιγαίου",
    "harbour": "Λιμάνι",
    "aegeanDescription": "Εξερεύνησε το λιμάνι: επισκεύασε σταθμούς, χρησιμοποίησε ρουτίνες και στείλε έναν αριθμό με κάθε παραγγελία.",
    "templeBetaNote": "Beta · Αναθεωρούμε τα παζλ και τα μαθήματα",
    "aegeanBetaNote": "Beta · Τα πρώτα 3 επίπεδα στο λιμάνι",
    "seasonal": "Εποχική περιπέτεια",
    "choosePreview": "Διάλεξε επίπεδο προεπισκόπησης",
    "repairs": "Επισκευές",
    "reachExit": "Φτάσε στην έξοδο",
    "taskRequirements": "Στόχοι αποστολής",
    "lessonGuided": "Καθοδηγούμενη άσκηση · συμπλήρωσε το έτοιμο πρόγραμμα",
    "lessonRepair": "Εντοπισμός λαθών · διόρθωσε το έτοιμο πρόγραμμα",
    "lessonChallenge": "Πρόκληση · φτιάξε το δικό σου πρόγραμμα",
    "acc_define_parameter": "Ρουτίνα",
    "acc_call_argument": "Κάλεσε ρουτίνα",
    "acc_repeat_parameter": "Επανάλαβε με είσοδο",
    "parameter": "παράμετρος",
    "argument": "στείλε",
    "callInput": "Η είσοδος αυτής της κλήσης",
    "inputWaiting": "Πάτησε Εκτέλεση ή Βήμα για να δεις την επόμενη είσοδο.",
    "argumentMismatch": "Μια ρουτίνα με παράμετρο χρειάζεται κλήση με έναν αριθμό. Μια ρουτίνα χωρίς παράμετρο χρειάζεται απλή κλήση.",
    "unsetParameter": "Χρησιμοποίησε την παράμετρο μόνο μέσα στη ρουτίνα που τη δέχεται. Οι παράμετροι είναι χωριστές από την κοινή μνήμη.",
    "memoryObjective": "Έλεγξε την καταγραφή επισκευών και τους στόχους εξόδου. Κάθε πρόγραμμα που τους καλύπτει είναι δεκτό.",
    "gate": "Ο δρόμος είναι κλειστός. Έλεγξε τις επισκευές που εκκρεμούν.",
    "noPickup": "Στάσου στο εργαλείο πριν το μαζέψεις.",
    "creditLead": "Επικεφαλής ομάδας και ανάπτυξη λογισμικού",
    "creditArt": "Εικονογράφηση και σκηνικά",
    "creditAnimation": "Κίνηση χαρακτήρων",
    "creditUX": "Σχεδιασμός διεπαφής και εμπειρίας χρήστη",
    "creditDesign": "Σχεδιασμός παιχνιδιού",
    "creditStory": "Συγγραφή ιστορίας",
    "creditAudio": "Μουσική και ηχοληψία",
    "lightLamp": "Άναψε τη λάμπα",
    "oilLamp": "Λυχνάρι",
    "dustyStation": "σκονισμένος σταθμός",
    "betaLabel": "Beta",
    "noLamp": "Στάσου σε μια σβηστή λάμπα πριν την ανάψεις.",
    "collected": "Μάζεψες το εργαλείο · έτοιμο για χρήση",
    "dustyPrompt": "Στάσου σε έναν σκονισμένο σταθμό πριν χρησιμοποιήσεις το πινέλο.",
    "lampMissing": "Μάζεψε πρώτα το λυχνάρι. Κοίτα στο σακίδιό σου.",
    "recursiveRoutine": "Η ρουτίνα καλεί τον εαυτό της. Χρησιμοποίησε άλλη ρουτίνα· οι αναδρομικές κλήσεις δεν είναι ακόμη διαθέσιμες."
  },
  "content": {
    "jungle.title": "Εξερεύνηση στη ζούγκλα",
    "jungle.description": "Ακολούθησε το μονοπάτι προς τον χαμένο ναό.",
    "jungle-1": "Πρώτα βήματα",
    "jungle-2": "Λίγο πιο μακριά",
    "jungle-3": "Στη γωνία",
    "jungle-4": "Άλλαξε κατεύθυνση",
    "jungle-5": "Ακολούθησε το μονοπάτι",
    "jungle-6": "Μια νέα διαδρομή",
    "jungle-7": "Νέα μονοπάτια",
    "jungle-8": "Σταυροδρόμι στη ζούγκλα",
    "jungle-9": "Βρες τον δρόμο σου",
    "jungle-10": "Σκέψου το επόμενο βήμα",
    "jungle-11": "Το μακρύ μονοπάτι",
    "jungle-12": "Μια διαδρομή με στροφές",
    "jungle-13": "Ένα τολμηρό άλμα",
    "jungle-14": "Κρυμμένα μοτίβα",
    "jungle-15": "Επανάλαβε τον ρυθμό",
    "jungle-16": "Διάλεξε μονοπάτι",
    "jungle-17": "Κοίτα πριν πηδήξεις",
    "jungle-18": "Διάβασε το μονοπάτι",
    "jungle-19": "Μια έξυπνη παράκαμψη",
    "jungle-20": "Κάτω από τα δέντρα",
    "jungle-21": "Γέφυρες παντού",
    "jungle-22": "Πέρα από το ποτάμι",
    "jungle-23": "Εξερεύνησε τα ερείπια",
    "jungle-24": "Πέτρα και ξύλο",
    "jungle-25": "Ένα μεγαλύτερο άλμα",
    "jungle-26": "Ακολούθησε τα σημάδια",
    "jungle-27": "Πιο ψηλά",
    "jungle-28": "Συνέχισε την εξερεύνηση",
    "jungle-29": "Στροφές και μονοπάτια",
    "jungle-30": "Ο μυστικός κήπος",
    "jungle-31": "Κρυμμένα μοτίβα",
    "jungle-32": "Αρχαία μονοπάτια",
    "jungle-33": "Οι τελευταίες στροφές",
    "jungle-34": "Προς τον ναό",
    "jungle-35": "Σχεδόν φτάσαμε",
    "jungle-36": "Ο χαμένος ναός",
    "winter.title": "Χειμωνιάτικο μονοπάτι",
    "winter.description": "Φώτισε κάθε βήμα στο χιόνι.",
    "winter-1": "Βήματα στο χιόνι",
    "winter-2": "Μια άλλη κατεύθυνση",
    "winter-3": "Παγωμένες γωνίες",
    "winter-4": "Ο μακρύς δρόμος",
    "winter-5": "Χιονονιφάδα",
    "winter-6": "Χειμωνιάτικες επαναλήψεις",
    "winter-7": "Εξερευνητής του πάγου",
    "winter-8": "Στροφές παντού",
    "winter-9": "Παγωμένη λογική",
    "winter-10": "Ανακάλυψε το μοτίβο",
    "winter-11": "Άρχοντας του μονοπατιού",
    "winter-12": "Χειμωνιάτικο θαύμα",
    "temple.title": "Ο χαμένος ναός",
    "temple.description": "Σαράντα συνδεδεμένοι θάλαμοι. Αποκατάστησε μια ουράνια συσκευή με εργαλεία, μνήμη και τις δικές σου ρουτίνες."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Κάδος, προς το παρόν άδειος",
    "OPEN_TRASH": "Άνοιγμα κάδου",
    "BLOCK_LABEL_BEGIN_STACK": "Αρχή αλυσίδας",
    "WORKSPACE_LABEL_1_STACK": "1 αλυσίδα εντολών",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 αλυσίδες εντολών",
    "ARIA_TYPE_FIELD_NUMBER": "αριθμός",
    "ARIA_TYPE_FIELD_DROPDOWN": "αναπτυσσόμενη λίστα",
    "ARIA_TYPE_FIELD_IMAGE": "εικόνα",
    "WORKSPACE_LABEL_PLAIN": "Το τετράδιό μου",
    "FIELD_LABEL_EDIT_PREFIX": "Επεξεργασία: %1",
    "BLOCK_LABEL_HAS_INPUT": "έχει είσοδο",
    "BLOCK_LABEL_HAS_INPUTS": "έχει εισόδους",
    "BLOCK_LABEL_HAS_BRANCHES": "έχει %1 κλάδους",
    "FIELD_LABEL_OPTION_INDEX": "Επιλογή %1",
    "INPUT_LABEL_EMPTY": "Κενό",
    "BLOCK_LABEL_DISABLED": "ανενεργό",
    "BLOCK_LABEL_COLLAPSED": "συμπτυγμένο",
    "BLOCK_LABEL_BEGIN_PREFIX": "Αρχή: %1",
    "INPUT_LABEL_END_STATEMENT": "Τέλος: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "κείμενο",
    "ARIA_TYPE_FIELD_INPUT": "είσοδος",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "όνομα εισόδου",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "όνομα ρουτίνας"
  }
}
